import React, { Fragment, useEffect, useState } from "react";
import ContentContainer from "./ContentContainer";
import { set_user } from "../../redux/actions/AuthAction";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/VendorSidebar/Sidebar";
import "./pagecontainer.scss";
import { Redirect, useHistory } from "react-router-dom";
import { apiJson } from "../../api/Api";
import { connect } from "react-redux";

const PageContainer = (props) => {
  const [goBack, setGoBack] = useState(false);
  var authenticated = localStorage.getItem("access_token");
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      apiJson.auth.validateToken().then((response) => {
        if (response.success) {
          localStorage.setItem(
            "access_token",
            response.headers["access-token"],
          );
          localStorage.setItem("client", response.headers.client);
          localStorage.setItem("uid", response.headers.uid);

          props.set_user({
            isSignedIn: true,
            user: response.data.data,
          });
        } else {
          if (parseInt(response.status) === 401) {
            props.set_user({ isSignedIn: false, user: {} });
            localStorage.clear();
            document.cookie =
              "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
            setGoBack(true);
          }
        }
      });
    } else {
      document.cookie =
        "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
    }
    // eslint-disable-next-line
  }, [history.location.pathname]);

  return (
    <Fragment>
      {authenticated ? (
        <div className="page-container-desktop d-flex">
          <div className="left">
            <Sidebar />
          </div>
          <div id="rightContent" className="right">
            <Header />
            <ContentContainer />
          </div>
        </div>
      ) : (
        <Redirect to="/" />
      )}
      {goBack && <Redirect to="/" />}
    </Fragment>
  );
};

const mapDispatchToProps = {
  set_user,
};

export default connect(null, mapDispatchToProps)(PageContainer);
